export const domains = {
  dev: process.env.NEXT_PUBLIC_DOMAIN_DEV || 'https://dev.giftcardmarket.com',
  qa: process.env.NEXT_PUBLIC_DOMAIN_QA || 'https://qa.giftcardmarket.com',
  demo: process.env.NEXT_PUBLIC_DOMAIN_DEMO || 'https://demo.giftcardmarket.com',
  prod: process.env.NEXT_PUBLIC_DOMAIN_PROD || 'https://www.giftcardmarket.com',
  b2b_dev: process.env.NEXT_PUBLIC_B2B_DOMAIN_DEV || 'https://dev.b2b.giftcardmarket.com',
  b2b_qa: process.env.NEXT_PUBLIC_B2B_DOMAIN_QA || 'https://qa.b2b.giftcardmarket.com',
  partner_dev: process.env.NEXT_PUBLIC_PARTNER_DOMAIN_DEV || "https://devpartner.giftcardmarket.com",
  partner_qa: process.env.NEXT_PUBLIC_PARTNER_DOMAIN_QA || "https://qapartner.giftcardmarket.com",
  partner_demo: process.env.NEXT_PUBLIC_PARTNER_DOMAIN_DEMO || "https://demopartner.giftcardmarket.com",
  partner_prod: process.env.NEXT_PUBLIC_PARTNER_DOMAIN_PROD || "https://partner.giftcardmarket.com"
} as const